export default __webpack_public_path__ + "static/media/smart_assistant_avatar_green.2fc2cf7a.png";